import React from 'react';
import { Link } from 'react-router-dom';
import { List, Badge, Icon } from 'antd';
import cn from 'classnames';
import { notificationsConfig as config } from '../../../../shared/constants';
import ActionBtn from '../../../../shared/ui/ActionBtn/ActionBtn';
import { ToggleViewNotification } from '../../../../features/toggleNotificationView';
import styles from './Notification.module.scss';

const Notification = ({ notification, onLinkClick }) => {
  const handleLinkClick = ({ read }) => {
    if (notification.isNew) {
      read({ id: notification.id });
    }

    if (typeof onLinkClick === 'function') {
      onLinkClick(notification);
    }
  };

  return (
    <List.Item className={styles.root}>
      <div className={styles.leftCol}>
        <div className={styles.badgeBlock}>
          {notification.isNew && (
            <Badge className={styles.badge} color="#faad14" dot />
          )}
        </div>
        <ToggleViewNotification
          render={({ read }) => (
            <Link
              className={cn(styles.link, {
                [styles.accent]: notification.isNew,
              })}
              onClick={() => handleLinkClick({ read })}
              to={{
                pathname: config[notification.mode].route,
                state: {
                  id: notification.sourceId,
                  from: 'notifications',
                  texts: {
                    title: notification.title,
                    fallbackText: config[notification.mode].fallbackText,
                  },
                },
              }}
            >
              {notification.title}
            </Link>
          )}
        />
      </div>
      {notification.isNew ? (
        <ToggleViewNotification
          render={({ read, isReadLoading }) => (
            <ActionBtn
              className={styles.readBtn}
              tooltipProps={{
                title: `Отметить как ${
                  notification.isNew ? 'прочитанное' : 'непрочитанное'
                }`,
              }}
              onClick={
                notification.isNew
                  ? () => read({ id: notification.id })
                  : undefined
              }
            >
              <Icon type={isReadLoading ? 'loading' : 'check'} />
            </ActionBtn>
          )}
        />
      ) : null}
    </List.Item>
  );
};

export default Notification;
